import React, { useState } from 'react';
import {
  Link
} from "@mui/material";

interface Props { 
  selected: number;
  page_count: number;
  onChange: (page: number) => void;
}

export default function PageLinks({ 
  selected,
  page_count,
  onChange,
}: Props) {
  const [ping, setPing] = useState(false);

  const return_us: any[] = [];
  if (page_count > 1) {
    const start = Math.max(0, selected - 3);
    const end = Math.min(page_count, selected + 4);
    let key = 0;
    if (selected > 0) {
      return_us.push(
        <div key={key} style={{ float: "left", margin: "4px" }}>
          <Link href="#" onClick={(event: React.SyntheticEvent) => {
            event.preventDefault();
            onChange(selected - 1);
            setPing(!ping);
            }}>
            Back
          </Link>
        </div>
      );
      key++;
    } else {
      return_us.push(<div key={key} style={{ float: "left", margin: "4px" }}>Back</div>);
      key++;
    }
    // return_us.push(<div key={key} style={{ float: "left", margin: "4px" }}>&nbsp;</div>);
    // key++;
    if (selected < page_count - 1) {
      return_us.push(
        <div key={key} style={{ float: "left", margin: "4px" }}>
          <Link href="#" onClick={(event: React.SyntheticEvent) => {
            event.preventDefault();
            onChange(selected + 1);
            setPing(!ping);
            }}>
            Next
          </Link>
        </div>
      );
      key++;
    } else {
      return_us.push(<div key={key} style={{ float: "left", margin: "4px" }}>Next</div>);
      key++;
    }
    // return_us.push(<div key={key} style={{ float: "left", margin: "4px" }}>&nbsp;</div>);
    // key++;
    if (start > 0) {
      return_us.push(
        <div key={key} style={{ float: "left", margin: "4px" }}>
          <Link href="#" onClick={(event: React.SyntheticEvent) => {
            event.preventDefault();
            onChange(0);
            setPing(!ping);
            }}>
            1
          </Link>
        </div>
      );
      key++;
      // return_us.push(<div key={key} style={{ float: "left", margin: "4px" }}>&nbsp;</div>);
      // key++;
    }
    if (start > 1) {
      return_us.push(<div key={key} style={{ float: "left", margin: "4px" }}>...</div>);
      key++;
    }
    for (let i = start; i < end; i++) {
      if (selected === i) {
        return_us.push(<div key={key} style={{ float: "left", margin: "4px" }}>{ i + 1}</div>);
      } else {
        return_us.push(
          <div key={key} style={{ float: "left", margin: "4px" }}>
            <Link href="#" onClick={(event: React.SyntheticEvent) => {
              event.preventDefault();
              onChange(i);
              setPing(!ping);
              }}>
              { i + 1 }
            </Link>
          </div>
        );
      }
      key++;
      // return_us.push(<div key={key} style={{ float: "left", margin: "4px" }}>&nbsp;</div>);
      // key++;
    }
    if (end < page_count - 1) {
      return_us.push(<div key={key} style={{ float: "left", margin: "4px" }}>...</div>);
      key++;
    }
    if (end < page_count) {
      return_us.push(
        <div key={key} style={{ float: "left", margin: "4px" }}>
          <Link href="#" onClick={(event: React.SyntheticEvent) => {
            event.preventDefault();
            onChange(page_count - 1);
            setPing(!ping);
            }}>
            { page_count }
          </Link>
        </div>
      );
      key++;
    }
  }
  return (
    <span>
      { return_us }
    </span>
  );
}
